import { toggle } from "@otto-ec/global-resources/toggle";
import { createExpiryScheduler, type ExpiryScheduler } from "utils/expiry";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export abstract class BenefitElement extends HTMLElement {
	expiry: ExpiryScheduler = createExpiryScheduler();

	/**
 *
 *
 */
	#initialized = false;

	/**
 *
 */
	connectedCallback(): void {
		if (this.#initialized) {
			return;
		}
		this.#initialized = true;
		void this.onInit();
	}

	/**
 *
 */
	disconnectedCallback(): void {
		this.expiry.cleanup();
	}

	/*                                                                                        */
	protected abstract onInit(): Promise<void>;

	/*                                                                 */
	protected abstract callBackend(): Promise<void>;

	/*                                                                */
	protected abstract createSearchParams(): URLSearchParams;

	/**
 *
 *
 */
	protected buildSearchParams(params: Record<string, string | null | undefined>): URLSearchParams {
		const urlSearchParams = new URLSearchParams();
		for (const [key, value] of Object.entries(params)) {
			if (value != null) {
				urlSearchParams.append(key, value);
			}
		}
		return urlSearchParams;
	}

	/*                                                       */
	async triggerReload(): Promise<void> {
		await this.callBackend();
	}

	/**
 *
 *
 */
	protected triggerReloadAt(expirationDate: string): void {
		this.expiry.scheduler(expirationDate, () => void this.callBackend());
	}
}

/**
 *
 *
 */
export function defineElement(elementClass: CustomElementConstructor, name: string, toggleKey: string): void {
	if (customElements && customElements.get(name) === undefined && !toggle.get(toggleKey, false)) {
		customElements.define(name, elementClass);
	}
}
